import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineSeparator,
} from "@mui/lab";
import { Button, Paper } from "@mui/material";
import EditFormControl from "components/form/EditFormControl";
import CustomText from "components/typography/CustomText";
import moment from "moment";
import { useState } from "react";
import { openLoading } from "store/reducers/tools";
import { serverPost } from "lib/serverRequest";
import { useSnackbar } from "notistack";
import { ERR_NETWORK } from "constants/messages";
import CustomTab from "components/CustomTab";

export function HistoryContent({ time = "", historyText = "", log = {} }) {
  return (
    <TimelineItem className="px-0">
      <TimelineSeparator>
        <TimelineDot />
        <TimelineConnector />
      </TimelineSeparator>
      <TimelineContent>
        <CustomText className="text-13" variant="body" bold={500}>
          {time}
        </CustomText>
        <div>
          <CustomText className="text-13 my-2 cursor-pointer" variant="body">
            {historyText}
          </CustomText>
        </div>
      </TimelineContent>
    </TimelineItem>
  );
}

const HistoryContentPostmark = ({ log = {} }) => {
  const openNewTab = () => {
    const newTab = window.open("about:blank", "_blank");
    const newDocument = newTab.document;
    const newHtml = log.body;
    newDocument.open();
    newDocument.write(newHtml);
    newDocument.close();
  };
  return (
    <TimelineItem className="px-0">
      <TimelineSeparator>
        <TimelineDot />
        <TimelineConnector />
      </TimelineSeparator>
      <TimelineContent>
        <CustomText className="text-13" variant="body" bold={500}>
          {moment(log?.created_at).format("MMM DD, YYYY. HH:mm A")}
        </CustomText>
        <div>
          <CustomText
            className="text-13 my-2 cursor-pointer"
            variant="body"
            onClick={openNewTab}
          >
            {log?.subject ?? ""}
          </CustomText>
        </div>
      </TimelineContent>
    </TimelineItem>
  );
};

export default function HistoryTimeline({
  title = "Timeline",
  logs = {},
  user = {},
  onSend = () => {},
}) {
  const { enqueueSnackbar } = useSnackbar();
  const [data, setData] = useState({});
  const [activeTab, setActiveTab] = useState({
    tab: "pie-club",
    label: "Pie Club",
  });
  const handleSend = () => {
    openLoading(true);
    if (!Boolean(data?.mailText)) return;
    serverPost({
      url: `user/setNote`,
      data: {
        log_data: {
          user_id: user?.id ?? "",
          changer_type: "note",
          log: data?.mailText ?? "",
        },
      },
      onFinish: (res) => {
        openLoading(false);
        if (res !== false) {
          enqueueSnackbar("Note added successfully", { variant: "success" });
          onSend(res?.[0]);
          setData({});
        } else enqueueSnackbar(ERR_NETWORK.LONG, { variant: "warning" });
      },
    });
  };
  return (
    <div className="pb-10">
      <Paper>
        <div className="p-4 flex justify-between items-center border-b border-white-gray">
          <CustomText variant="h6" bold={600}>
            {title}
          </CustomText>
        </div>
        <div className="flex p-4">
          <EditFormControl
            className="flex-1 pl-6"
            name="mailText"
            data={data}
            fullWidth={true}
            onChange={(e) => setData({ mailText: e.target.value })}
          />
          <Button variant="contained" color="secondary" onClick={handleSend}>
            Add Note
          </Button>
        </div>
        <div className="px-4 max-h-96 overflow-auto scroll-thumb">
          <div className="flex items-center">
            <CustomTab
              tabs={[
                { tab: "pie-club", label: "Pie Club" },
                { tab: "postmark", label: "Postmark" },
              ]}
              activeTab={activeTab}
              onClick={(v) => setActiveTab(v)}
              size="small"
            />
          </div>
          <Timeline className="px-0">
            {activeTab.tab === "pie-club"
              ? logs?.pieclub?.map((log, index) => (
                  <HistoryContent
                    log={log}
                    key={index}
                    index={index}
                    time={moment(log?.created_at).format(
                      "MMM DD, YYYY. HH:mm A"
                    )}
                    historyText={log?.log ?? ""}
                  />
                ))
              : logs?.postmark?.map((log, logIndex) => (
                  <HistoryContentPostmark log={log} key={logIndex} />
                ))}
          </Timeline>
        </div>
      </Paper>
    </div>
  );
}
